import(/* webpackMode: "eager" */ "/app/src/classes/FetchWithInterceptor.ts");
import(/* webpackMode: "eager" */ "/app/src/components/car-details/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/translations/client-setup.ts")